import type { TravelledVehicle } from "../../common/graphql/fragments/gql/TravelledVehicle";
import type { VehicleType } from "../../common/graphql/fragments/gql/VehicleType";

export enum TravelledVehicleType {
  Vehicle,
  Trailer,
}

export interface RegistrationNumberAlertFormState {
  appliedArrivalNotepad: boolean;
  appliedGoods: boolean;
  appliedHazardousGoods: boolean;
  appliedHeight: boolean;
  appliedLength: boolean;
  appliedLoadingListMessage: boolean;
  appliedTravelledVehicle: boolean;
  result: TravelledVehicle | null;
  travelledVehicleType: TravelledVehicleType;
  vehicleType: VehicleType | null;
}
